export default "__VITE_ASSET__BPSUhM$q__";